<template>
  <div class="">
    <v-tabs :value="selectedTabs" @change="setSelectedTabs">
      <v-tab
        v-for="(item, i) in workAgent"
        :key="i"
        color="deep-purple accent-4"
      >
        <span v-if="i === 0">Стандарт</span>
        <div v-else>Акция {{ i }}</div>
      </v-tab>
      <div class="v-tab" color="deep-purple accent-4" @click="addSale">
        Добавить Акцию +
      </div>
      <v-tab-item v-for="(item, i) in workAgent" :key="i">
        <div style="display: flex; justify-content: space-between">
          <DateWithMenu
            v-if="i > 0"
            placeholder="Дата Акции"
            v-model="item.saleDate"
            :init="false"
          />
          <v-btn v-if="i > 0" color="default" @click="() => copyStandart(item)"
            >Скопировать</v-btn
          >
          <v-btn v-if="i > 0" color="error" @click="() => removeSale(item.id)">
            Удалить Акцию
          </v-btn>
        </div>

        <v-radio-group v-model="item.what_fee">
          <v-radio
            v-for="item in radio"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </v-radio-group>
        <v-row v-if="item.what_fee === 'range'">
          <v-col cols="3">
            <v-text-field
              v-model="item.agentsFeeMin"
              label="Мин значение %"
              type="number"
              step="0.01"
              :error-messages="
                item.agentsFeeMinType != 5 && item.agentsFeeMin >= 0
                  ? 'Поле должно быть заполнено'
                  : undefined
              "
            />
          </v-col>
          <v-col cols="3">
            <v-select
              v-model="item.agentsFeeMinType"
              :items="feeType"
              label="Единицы измерения"
              item-text="name"
              item-value="id"
            />
          </v-col>
          <v-col cols="3">
            <v-text-field
              v-model="item.agentsFeeMax"
              label="Макс значение %"
              type="number"
              step="0.01"
              :error-messages="
                item.agentsFeeMaxType !== 5 && item.agentsFeeMax >= 0
                  ? 'Поле должно быть заполнено'
                  : undefined
              "
            />
          </v-col>
          <v-col cols="3">
            <v-select
              v-model="item.agentsFeeMaxType"
              :items="feeType"
              label="Единицы измерения"
              item-text="name"
              item-value="id"
            />
          </v-col>
        </v-row>
        <v-row v-if="item.what_fee === 'netto'">
          <v-col cols="3">
            <v-text-field
              v-model="item.nettoFee"
              label="Нетто мини. значение%"
              type="number"
              step="0.01"
            />
          </v-col>
          <v-col cols="3">
            <v-select
              v-model="item.nettoFeeType"
              :items="feeType"
              label="Единицы измерения"
              item-text="name"
              item-value="id"
            />
          </v-col>
          <v-col cols="3">
            <v-text-field
              v-model="item.nettoFeeMax"
              label="Нетто макс. значение %"
              type="number"
              step="0.01"
            />
          </v-col>
          <v-col cols="3">
            <v-select
              v-model="item.nettoFeeMaxType"
              :items="feeType"
              label="Единицы измерения"
              item-text="name"
              item-value="id"
            />
          </v-col>
        </v-row>

        <!-- <v-select
          v-model="product.agentsfeesVal"
          :items="product.agentsfees"
          label="Условия работы с агентами:"
          item-text="name"
          item-value="id"
          chips
          multiple
        /> -->

        <v-textarea
          v-model="item.agentsfee_note"
          label="Условия работы с агентами (примечание):"
        />
        <v-checkbox
          v-model="item.up_box"
          label="Возможность согласовать повышенное АВ"
        />
        <v-textarea
          v-model="item.up_description"
          label="Условия согласования повышения АВ"
        />
        <fieldset>
          <legend>
            Условия выплат агентам при превышении стандартного тарифа
          </legend>
          <v-row v-if="item.what_fee === 'range'">
            <v-col cols="3">
              <v-text-field
                v-model="item.agentsupMin"
                label="Мин значение %"
                type="number"
                step="0.01"
              />
            </v-col>
            <v-col cols="3">
              <v-select
                v-model="item.agentsupMinType"
                :items="feeType"
                label="Единицы измерения"
                item-text="name"
                item-value="id"
              />
            </v-col>
            <v-col cols="3">
              <v-text-field
                v-model="item.agentsupMax"
                label="Макс значение %"
                type="number"
                step="0.01"
              />
            </v-col>
            <v-col cols="3">
              <v-select
                v-model="item.agentsupMaxType"
                :items="feeType"
                label="Единицы измерения"
                item-text="name"
                item-value="id"
              />
            </v-col>
          </v-row>

          <v-textarea
            v-model="item.agentsup_note"
            label="Условия выплат агентам при превышении стандартного тарифа (примечание):"
          />
        </fieldset>
        <fieldset>
          <legend>Условия выплат агентам при снижении</legend>
          <v-row>
            <v-col cols="2">
              <v-checkbox v-model="item.down_bank" label="за счет Банка" />
            </v-col>
            <v-col cols="2">
              <v-checkbox v-model="item.down_agent" label="за счет Агента" />
            </v-col>
            <v-col cols="2">
              <v-checkbox
                v-model="item.down_bank_agent"
                label="За счет Банка и Агента"
              />
            </v-col>
          </v-row>
          <v-textarea
            v-model="item.down_description"
            label="Условия выплат агентам при снижении стандартного тарифа (примечание):"
          />
          <v-row>
            <v-col cols="2">
              <v-checkbox v-model="item.min_tarif" label="Минимальный тариф" />
            </v-col>
            <v-col cols="4" v-if="item.min_tarif">
              <v-text-field
                v-model="item.minFee"
                label="Значение"
                type="number"
                step="0.01"
              />
            </v-col>
            <v-col cols="4" v-if="item.min_tarif">
              <v-select
                v-model="item.minFeeType"
                :items="feeType"
                label="Единицы измерения"
                item-text="name"
                item-value="id"
              />
            </v-col>
          </v-row>
          <v-row v-if="item.min_tarif">
            <v-col cols="12">
              <v-textarea
                v-model="item.min_tarif_note"
                label="Минимальный тариф (примечание):"
              />
            </v-col>
          </v-row>
        </fieldset>

        <fieldset>
          <legend>Выплаты АВ</legend>
          <span
            v-if="
              !item.edo_sdelka &&
              !item.edo_mounth &&
              !item.edo_decada &&
              !item.edo_week &&
              !item.edo_personal
            "
            style="color: red"
            >Поле должно быть заполнено</span
          >
          <v-row>
            <v-col cols="2">
              <v-checkbox v-model="item.edo_sdelka" label="по сделке" />
            </v-col>
            <v-col cols="2">
              <v-checkbox v-model="item.edo_mounth" label="ежемесячно" />
            </v-col>
            <v-col cols="2">
              <v-checkbox v-model="item.edo_decada" label="по декадам" />
            </v-col>
            <v-col cols="2">
              <v-checkbox v-model="item.edo_week" label="еженедельно" />
            </v-col>
            <v-col cols="2">
              <v-checkbox v-model="item.edo_personal" label="индивидуально" />
            </v-col>
          </v-row>

          <v-textarea v-model="item.edo" label="Примечание Выплаты" />
        </fieldset>
      </v-tab-item>
    </v-tabs>
  </div>
</template>
<script>
import DateWithMenu from "@/components/DateWithMenu.vue";
import calcConsts from "@/plugins/calcConsts";

export default {
  name: "workwithagent",
  components: { DateWithMenu },
  data: () => ({
    radio: calcConsts.radio,
    feeType: calcConsts.feeType,
  }),
  props: {
    itemProduct: {},
    product: {},
  },
  methods: {
    copyStandart(item) {
      this.$store.dispatch("copyStandart", item);
    },
    async init() {
      const obj = {
        bank_id: this.itemProduct.bank,
        product_id: this.itemProduct.id,
      };
      return await this.$store.dispatch("getAllSale", obj);
    },
    async removeSale(id) {
      await this.$store.dispatch("removeSale", id);
    },
    async addSale(ev, standart = false) {
      const ip = JSON.parse(JSON.stringify(this.itemProduct));
      const obj = {
        bank_id: ip.bank,
        product_id: ip.id,
        standart,
      };
      await this.$store.dispatch("addSale", obj);
    },
    setSelectedTabs(e) {
      if (e > 0) {
        this.$store.commit("SET_WORK_AGENT_TAB", e);
      }
    },
  },
  computed: {
    workAgent() {
      return this.$store.getters.getWorkAgent;
    },
    selectedTabs() {
      return this.$store.getters.getSelectedWorkAgent;
    },
  },
  mounted() {},
  watch: {
    async itemProduct() {
      const data = await this.init();
      !data && this.addSale("", true);
    },
  },
};
</script>
<style lang="sass" scoped>
fieldset
  padding: 0 20px
  border-right-style: hidden
  border-left-style: hidden
  border-color: #217899
  legend
    padding: 0 10px
</style>
